import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/sections/Hero";
import Services from "../components/sections/Services";
import ValueProp from "../components/sections/ValueProp";
import Process from "../components/sections/Process";
import About from "../components/sections/About";
import CTA from "../components/sections/CTA";
import Footer from "../components/sections/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-50 antialiased" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <ValueProp />
        <Process />
        <About />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
